import withT from "neetocommons/react-utils/withT";
import { DownArrow } from "neetoicons";
import { Typography } from "neetoui";

const Skeleton = withT(({ t }) => (
  <div className="flex flex-col gap-y-4">
    <div className="neeto-ui-bg-gray-200 neeto-ui-rounded-lg h-12 w-full" />
    <div className="neeto-ui-bg-gray-200 neeto-ui-text-gray-600 neeto-ui-rounded-lg flex w-full flex-col items-center justify-center gap-y-2 px-16 py-8">
      <Typography
        className="text-center"
        data-testid="build-page-text-label"
        lineHeight="normal"
        style="body2"
      >
        {t("neetoMolecules.builderSidebar.emptyQuestionProperties")}
      </Typography>
      <DownArrow />
    </div>
    <div className="neeto-ui-bg-gray-200 neeto-ui-rounded-lg h-40 w-full" />
    <div className="neeto-ui-bg-gray-200 neeto-ui-rounded-lg h-72 w-full" />
  </div>
));

export default Skeleton;
